import React, { useState,  useEffect } from 'react'
import "../../styles/AddLawer2Styles.css"
import axios from "axios";
import { getUrl } from '../../ApiCall/GetUrl';



import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';

import Select from 'react-select'


export default function Especialidades( { setEpecialPrecio}) { // Establece la especialidad y el precio
  const [espec, setEspecialidadesArr] = useState([]);
  const [presciosArr, setPreciosArr] = useState([]);

  const [espPrecio,setEspPrecio] = useState( null )

  const [especialidades,setEspecialidades] = useState([{value:"1" , label:"algo"}])
  const [precio,setPrecio] = useState("1")

  const [options,setOptions] = useState( [])

  const [checkPrimer,setCheckPrimer] = useState( false )
  const [valuePrimer,setValuePrimer] = useState( "500.00")


  function onSetValuePrimer( val )
  {

    console.log( "onSetValuePrimer = " , val )

    if ( val === "" || val === null )
    {
      val = "500.00"
      console.log("onSetValuePrimer = ", val)

      if ( val  === valuePrimer)
      {
        //document.getElementById( "isFirstValue").innerHTML = val
        //return ; 

      }
      setValuePrimer( val )
      return ;
    }

    setValuePrimer( val )
  }

useEffect(()=>{

  var obj = {
    especialidad : especialidades ,

    precio : precio ,

    checkPrimer : checkPrimer ,
    valuePrimer : valuePrimer 

  }

  //setEspPrecio( obj )
  setEpecialPrecio( obj )




},[checkPrimer,valuePrimer])
  

  function onEspChanged( val )
  {

    console.log( "onEspChanged " , val )

    setEspecialidades( val )

    if ( true /* espPrecio === null*/ )
    {
      var obj = {
        especialidad : val ,

        precio : precio ,

        checkPrimer : checkPrimer ,
        valuePrimer : valuePrimer 

      }

      //setEspPrecio( obj )
      setEpecialPrecio( obj )
    }
    else{
      obj = espPrecio.precio ;

      obj.especialidad = val;

      setEspPrecio( obj ) // Hacemos la actualizacion
      setEpecialPrecio( obj )
    }
  }

  function onPrecioChanged( val )
  {
    console.log( "onPrecioChanged " , val.target.value )
    if ( true /*espPrecio === null*/ )
    {
      var obj = {
        especialidad : especialidades ,

        precio : val.target.value  ,

        checkPrimer : checkPrimer ,
        valuePrimer : valuePrimer

      }

      setEspPrecio( val.target.value )
      setEpecialPrecio( obj )
    }
    else{
      obj = espPrecio.especialidad ;

      obj.precio = val ;

      setEspPrecio( obj ) // Hacemos la actualizacion
      setEpecialPrecio( obj )
    }
  }

  useEffect(() => {

      var obj = {

        especialidad : especialidades ,

        precio : precio ,

        checkPrimer : checkPrimer ,
        valuePrimer : valuePrimer

      }

      setEpecialPrecio( obj )
    
    
      axios.get(getUrl() + "/get_lawyer_precios").then(response => {
        setPreciosArr(response.data);
        console.log("Precios Este es el response.data: ", response.data);
        getEspecialidades()
      }).catch(err => {
        setPreciosArr(["Hubo un error al traer los datos"]); 
      })
    


    

  } , [])

  function getEspecialidades()
  {
      axios.get(getUrl() + "/get_lawyer_especialidades").then(response => {
        console.log("Especialidades Este es el response.data: ", response.data);

        var arr =[]

        for ( var i = 0 ; i < response.data.length ; i++ )
          {
              var obj = {
  
                  value : response.data[i].id_especialidad ,
                  label : response.data[i].especialidad_name
              }
  
              console.log( "onjeto = " , obj )
  
              arr.push( obj ) ;
          }


          setOptions( arr )


        //setEspecialidadesArr( response.data);
        
      }).catch(err => {
        console.log( "Eerror en la especialidad")
        console.log( err )
        //setEspecialidadesArr(["Hubo un error al traer la información"]);
      })
  }

  return (
    <div className='row g-0 mt-4'>

      <div className='col-sm-4'>
        <div className="form-group  "   >
          <label className={"estilo_label"} htmlFor="especialidades">¿Cual(es) son tus especialidades? </label>
          <Select options={options} isMulti={true} onChange={onEspChanged}></Select>
          {/*<select placeholder="" type="text" onChange={(val) => onEspChanged( val )} 
            className={"form-control border-0 border-bottom estilo_input"} id="especialidades" title='Nombre de Abogado'

          >
          <option></option>
          {espec.map(v => 
              <option key={v.id_especialidad} value={v.id_especialidad}>{v.especialidad_name}</option>
              
            )}
          </select>*/} 

        </div>
      </div>

      <div className='col-sm-4'>
        <div className="form-group"   >
          <label className={"estilo_label derecho"} style={{ paddingLeft: "22px" }} htmlFor="precio">¿Cuál es el precio promedio de tu hora?</label>

          
          <select placeholder="" type="email" onChange={(val) => onPrecioChanged( val)}
            className={"form-control  border-0 border-bottom border-start estilo_input derecho"} id="precio" title='Nombre de Abogado'
          >
            
            {presciosArr.map(v => 
              <option value={v.id_rango} key={v.id_rango}>{v.rango}</option>
            )}
          </select> 

        </div>
      </div>

      <div className='col-sm-2'>
        <div className="form-group"   >
          <label className={"estilo_label derecho"} style={{ paddingLeft: "22px" }} htmlFor="isFirst">&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;¿Cargo primer </label>

          <Checkbox checked={checkPrimer} invalid={!checkPrimer} onChange={(e) =>  setCheckPrimer(e.checked)} inputId="isFirst"  />

        </div>
        
      </div>

      <div className='col-sm-2'>
        <div className="form-group"   >
          <label className={"estilo_label derecho"} style={{ paddingLeft: "22px" }} htmlFor="isFirstValue">consulta?</label>

          <InputNumber id="isFirstValue" value={valuePrimer} onChange={(e) => onSetValuePrimer(e.value)}  min={0} max={10000} minFractionDigits={2}/>
        
         
        </div>
      </div>

    </div>

  )
}
